import { Checkbox, SimpleGrid, Text } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { useTranslation } from 'react-i18next';
import { displayFormError } from 'utils/validation';
import { defaultMeasurementIndicators, getHeartRhythmIndicatorLabel } from 'utils/measurement';
import { AccordionWithSwitch } from './AccordionWithSwitch';

export const AlgorithmIndicatorFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors } = useCreateRuleFormContext();

  const dataField = 'data.heartRhythmMeasurement.indicatorCondition';

  const renderIndicatorLabels = () => {
    return (
      <SimpleGrid cols={1} verticalSpacing={'xs'} mb={'xs'}>
        {defaultMeasurementIndicators.map((indicator) => (
          <Checkbox
            key={indicator}
            value={indicator}
            label={getHeartRhythmIndicatorLabel(indicator)}
            disabled={values.formDisabled}
          />
        ))}
      </SimpleGrid>
    );
  };

  return (
    <AccordionWithSwitch
      title={`${t('algorithm_indicator_title')} *`}
      dataField={dataField}
      disabled={values.data.heartRhythmMeasurement.reviewedLabelCondition?.enabled}
    >
      <Text size={'xs'} mb={-5} c={'var(--mantine-color-blue-5)'}>
        {t('algorithm_indicator_description')}
      </Text>
      <Checkbox.Group
        {...getInputProps(`${dataField}.indicator`)}
        error={displayFormError({ errors, dataField: `${dataField}.indicator`, label: t('empty_value_select') })}
      >
        {renderIndicatorLabels()}
      </Checkbox.Group>
    </AccordionWithSwitch>
  );
};
